import { helper } from '@ember/component/helper';

/**
 * Converte un valore in numero gestendo stringhe con virgola
 */
const toNumber = val => {
  if (typeof val === 'number') return val;
  if (typeof val === 'string') return Number(val.replace(',', '.'));
  return NaN;
};

/**
 * Calcola la differenza tra numeri
 */
var numberDiff = helper(function numberDiff(numbers) {
  if (!Array.isArray(numbers) || numbers.length === 0) return 0;
  const validNumbers = numbers.map(toNumber).filter(n => !isNaN(n));
  if (validNumbers.length === 0) return 0;
  return validNumbers.reduce((acc, val) => acc - val);
});

export { numberDiff as default };
//# sourceMappingURL=number-diff.js.map
